import { PagingConfiguration } from '../paging-configuration';

export class PagingModel {
    configuration: PagingConfiguration;
    offset: number;
    limit: number;
    curItems: number;                   // items displayed
    totalItems: number;
    nextLink: string;
    prevLink: string;
    currentPage: number;
    totalPage: number;
    show: boolean;
    firstOfRange: number;
    lastOfRange: number;
    hasNextLink: boolean;
    hasPrevLink: boolean;

    constructor(offset: number, limit: number, curItems: number, totalItems: number,
                nextLink: string | null = null, prevLink: string | null = null, currentPage: number | null = null, totalPage: number | null = null,
                firstOfRange: number | null = null, lastOfRange: number | null = null) {
        this.configuration = new PagingConfiguration();
        this.offset = offset;
        this.limit = limit;
        this.curItems = curItems;
        this.totalItems = totalItems;
        this.nextLink = nextLink;
        this.prevLink = prevLink;
        this.currentPage = this.generateCurrentPage(currentPage);
        this.totalPage = this.generateTotalPage(totalPage);
        this.show = true;
        this.firstOfRange = this.generateFirstOfRange(firstOfRange);
        this.lastOfRange = this.generateLastOfRange(lastOfRange);
    }

    /**
     *
     * @param currentPage the page to set to the currentPage
     * @returns the currentPage from param. If null, retrieve the current page by paging attributes
     */
    generateCurrentPage(currentPage: number): number {
        if (currentPage) {
            return currentPage;
        }
        if (this.offset === 0) {
            return 1;
        } else {
            return (this.offset / this.limit) + 1;
        }
    }

    /**
     *
     * @param totalPage the page to set to the totalPage
     * @returns the totalPage from param. If null, retrieve the total page by paging attributes
     */
    generateTotalPage(totalPage: number): number {
        if (totalPage) {
            return totalPage;
        }
        return Math.ceil(this.totalItems / this.limit);
    }

    generateFirstOfRange(number: number) {
        if (number) {
            return number;
        } else if (this.totalItems === 0) { // if no elements in table
            return 0;
        }
        return this.offset + 1;
    }

    generateLastOfRange(number: number) {
        if (number) {
            return number;
        }
        return this.curItems + this.offset;
    }

    checkHasPrevLink() {
        return (this.prevLink && this.currentPage > 1) ? true : false;
    }

    checkHasNextLink() {
        return (this.nextLink && this.currentPage !== this.totalPage) ? true : false;
    }
}
